module.exports = __webpack_public_path__ + "media/images/errors/enrollment_not_found-5fc884b1aa17f8b0c3134a7990973a81.png";